import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { ProjectDataPerimetro } from '../../entities/project-data-perimetro.entity';
import { Panels3d } from './panels3d';
import { Poste3d } from './poste3d';
import { Varios3d } from './varios3d';

export class Datas3d {

	// 'CERCADO' o 'VERJA'.
	public familia = '';

	// Tipo de poste >> 'LUX50, LUX80, D60, ... '.
	public typePost = '';

	// Altura del muro.
	public heigthWall = 0;

	// Altura del perímetro.
	public heightPost = 0;

	// Tipo de bayoneta 'simple' = 'B' o 'doble' = 'BD'; '' sin bayoneta.
	public bayonet = "";

	// Color del perímtero en hexadecimal '#rrvvaa'; '' Galvanizado.
	public color: string;

	// La dirección es usada para los Cercados y las Verjas FAX y RITMO.
	// Indica por que lado debe colocarse la alambrada o el bastidor.
	// -1 izquierda (-x), 1 derecha (+x).
	public direction = -1;

	// Tipo de malla para CERCADOS o bastidor para VERJAS >> 'LUX_EXT, CLASSIC, MAXI-FAX, ... '.
	public mesh = '';

	// Indica si el perímetro está cerrado.
	public closed = false;

	// Distancia entre postes.
	public separation = 0;

	// Indica si tiene placa base, solo cuando tiene muro.
	public basePlaque = false;

	// Tramos: vallado o cercado, puerta, muro con vallado o cercado.
	public sections = [];

	// Coordenadas.
	public coors: any = [];

	//
	public perimetro: ProjectDataPerimetro;

	private static SCALE100 = 100.0;
	private static SCALE1000 = 1000.0;

	public constructor() { }

	// Actualizar el banco de datos del perímetro.
	public setDatas(perimetro: ProjectDataPerimetro, bastidores: Panels3d, postes: Poste3d, varios: Varios3d, WITH_3D = false) {
		// Cargar los marcadores.
		if (WITH_3D) varios.cargar3D(Varios3d.Marcador);

		// Asignar puntero al perímetro.
		this.perimetro = perimetro;

		// Guardar el tipo  de familia.
		this.familia = perimetro.producto.familia.tipo;

		// ########## PANEL
		let panel = perimetro.producto.panel;

		// Altura del perímetro (1 metro = 1000).
		this.heightPost = panel.alturaValor / Datas3d.SCALE1000;

		// mesh ej.: 'MAXI-FAX'.
		this.mesh = perimetro.producto.tipoPanel.modeloStr;

		// Color. '#DADADA' -> galvanizado.
		this.color = (perimetro.producto.hexColor === '#DADADA') ? '' : perimetro.producto.hexColor;

		// LUX ANUDADA tiene varias cargas con lo cual se trata de forma distinta.
		if (this.mesh.startsWith('LUX_ANUDADA')) {
			this.separation = 6;
			// Tipo de malla 15 o 30.
			let es15 = (perimetro.producto.panel.distAlambresVert == '15cm') ? '_15' : '_30';
			if (WITH_3D) {
				bastidores.cargar3D(this.mesh + 'Inicial_' + perimetro.producto.panel.altura + es15);
				bastidores.cargar3D(this.mesh + 'Centro_' + perimetro.producto.panel.altura + es15);
				bastidores.cargar3D(this.mesh + 'Carracas_' + perimetro.producto.panel.altura + es15);
			}
			this.mesh += '#_' + perimetro.producto.panel.altura + es15;
		}
		else {
			if(perimetro.producto.tipoPoste){
				if(perimetro.producto.tipoPoste.indexOf('Cuadrado') != -1 ){
					this.mesh = this.mesh += '_' + perimetro.producto.panel.altura + '_CUADRADO';
					// this.mesh += '_' + perimetro.producto.panel.altura;
					// Separación entre las bases de los postes.
					this.separation = bastidores.length(this.mesh);
					if (WITH_3D) bastidores.cargar3D(this.mesh);
				}else{
					this.mesh += '_' + perimetro.producto.panel.altura;
					// Separación entre las bases de los postes.
					this.separation = bastidores.length(this.mesh);
					if (WITH_3D) bastidores.cargar3D(this.mesh);
				}	
			}else{
				this.mesh += '_' + perimetro.producto.panel.altura;
				// Separación entre las bases de los postes.
				this.separation = bastidores.length(this.mesh);
				if (WITH_3D) bastidores.cargar3D(this.mesh);
			}
			
	


		}

		// ########## BAYONETAS
		// Tener en cuenta si tiene bayoneta.
		this.bayonet = '';
		if (perimetro.producto.tipoBayoneta === 'simple') {
			this.bayonet = 'B';
		} else if (perimetro.producto.tipoBayoneta === 'doble') {
			this.bayonet = 'BD';
		}
		if (this.bayonet != '' && WITH_3D) varios.cargar3D(Varios3d.Espino);

		// ########## POSTE
		// Tipo poste. Ejecuta carga.
		let anchoReal = (perimetro.producto.anchuraPoste && perimetro.producto.anchuraPoste != '') ?
			perimetro.producto.anchuraPoste : panel.posteExtremo;

		if (anchoReal === 'LUX50') {
			if (this.color === '') {
				if (WITH_3D) postes.cargar3D(Poste3d.LUX50G + this.bayonet);
				this.typePost = anchoReal + 'G' + this.bayonet;
			}
			else {
				if (WITH_3D) postes.cargar3D(Poste3d.LUX50 + this.bayonet);
				this.typePost = anchoReal + this.bayonet;
			}
		}
		else if (anchoReal === 'LUX80') {
			if (this.color === '') {
				if (WITH_3D) postes.cargar3D(Poste3d.LUX80G + this.bayonet);
				this.typePost = anchoReal + 'G' + this.bayonet;
			}
			else {
				if (WITH_3D) postes.cargar3D(Poste3d.LUX80 + this.bayonet);
				this.typePost = anchoReal + this.bayonet;
			}
		}
		else if (this.mesh.startsWith('RITMOCLIP')) {
			if (WITH_3D) postes.cargar3D(Poste3d.RitmoCLIP + this.bayonet);
			this.typePost = Poste3d.RitmoCLIP + this.bayonet;
		}
		else if (anchoReal === 'RITMO') {
			if (WITH_3D) postes.cargar3D(Poste3d.RitmoDH + this.bayonet);
			this.typePost = Poste3d.RitmoDH + this.bayonet;
		}
				//cargamos el poste nuevo de Decor60
		else if(perimetro.producto.tipoPoste && perimetro.producto.tipoPoste.indexOf('Cuadrado') != -1){
			if(WITH_3D) postes.cargar3D(Poste3d.C60);
			this.typePost = Poste3d.C60;
		}
		else {
			if (WITH_3D) postes.cargar3D(Poste3d.D60);
			this.typePost = Poste3d.D60;
		}

		// ########## TORNAPUNTAS
		if (this.familia == 'CERCADO' && WITH_3D) {
			if (this.color === '') {
				varios.cargar3D(Varios3d.TornaPuntasRectoG);
				varios.cargar3D(Varios3d.TornaPuntasDerechoG);
				varios.cargar3D(Varios3d.TornaPuntasIzquierdoG);
			}
			else {
				varios.cargar3D(Varios3d.TornaPuntasRecto);
				varios.cargar3D(Varios3d.TornaPuntasDerecho);
				varios.cargar3D(Varios3d.TornaPuntasIzquierdo);
			}
		}

		// ########## MURO Y ESCALONES
		// Altura del muro, si es 0 no tiene muro (1 metro 100).
		this.heigthWall = (perimetro.informacion.tieneMuro && perimetro.informacion.alturaMuro) ?
			(perimetro.informacion.alturaMuro / Datas3d.SCALE100) : 0;

		// Placa base y muro.
		this.basePlaque = false;
		if (this.heigthWall > 0) {
			if (WITH_3D) varios.cargar3D(Varios3d.Muro);
			this.basePlaque = perimetro.informacion.tienePlacaBase;
			if (this.basePlaque && WITH_3D) varios.cargar3D(Varios3d.PlacaBase);
		}
		else if (perimetro.informacion.elevaciones && perimetro.informacion.elevaciones.length > 0 && WITH_3D) {
			varios.cargar3D(Varios3d.Muro);
			
		}

		// ########## GENERAL
		// Comprobar si es un recinto cerrado.
		// El array de coordenadas debe ser mayor de 2 y la primera coordenada debe ser igual a la última.
		if (perimetro.coordenadas[0].dots === undefined) {
			this.closed = (perimetro.coordenadas.length > 2 &&
				perimetro.coordenadas[0].lng === perimetro.coordenadas[perimetro.coordenadas.length - 1].lng &&
				perimetro.coordenadas[0].lat === perimetro.coordenadas[perimetro.coordenadas.length - 1].lat);
		}
		else {
			this.closed = (perimetro.coordenadas.length > 2 &&
				perimetro.coordenadas[0].dots[0].lng === perimetro.coordenadas[perimetro.coordenadas.length - 1].dots[0].lng &&
				perimetro.coordenadas[0].dots[0].lat === perimetro.coordenadas[perimetro.coordenadas.length - 1].dots[0].lat);
		}

		// Puertas.
		if (perimetro.puertas.length > 0) {
			let init = 0;
			let end = perimetro.puertas.length; // Todas las puertas.
			let coor = perimetro.coordenadas;
			// Ajuste de las puertas.
			for (let door of perimetro.puertas) {
				let result = this.getXYByMargin(
					coor[door.lsp].lng, coor[door.lsp].lat,
					coor[door.lsp + 1].lng, coor[door.lsp + 1].lat, door.margen);
				door.lng = result.x;
				door.lat = result.y;
			}
		}
	}

	// Devuelve la coordenada xy sobre le línea (x1,y1,x2,y2) partiendo del % (margin) desde la coordenada (x1,y1).
	private getXYByMargin(x1: number, y1: number, x2: number, y2: number, margin: number) {
		// console.log("paso por aqui")
		let pB = { x: x2 - x1, y: y2 - y1 }; // Situarse en cero. pB.x -= pA.x; pB.y -= pA.y;
		let normalX = 1;
		if (pB.x < 0) { pB.x *= -1; normalX = -1; }
		let normalY = 1;
		if (pB.y < 0) { pB.y *= -1; normalY = -1; }
		// Longitud A-B.
		let hipotenuse = Math.sqrt(Math.pow(pB.x, 2) + Math.pow(pB.y, 2));
		let radio = (hipotenuse * margin) / 100; // %
		// Angulo en radianes.
		let angle = Math.asin(pB.y / hipotenuse);
		return {
			x: ((radio * Math.cos(angle)) * normalX) + x1,
			y: ((radio * Math.sin(angle)) * normalY) + y1
		};
	}
}